<template>
  <div>
    <HeaderBar :text="headerBar.text" :backgroundUrl="headerBar.backgroundUrl"></HeaderBar>

    <div class="container-fluid vision">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="image-info-background text-right">
              <img :src="`/${$staticPath}/${imageInfo[0].imageInfoBackground}`">
                <div class="content-image" :style="visionStyle">
                  <h1>
                    <strong>{{ imageInfo[0].header.head }}</strong>{{ imageInfo[0].header.text }}<div class="underline"></div>
                  </h1>
                  <div class="px-4 group">
                    <p v-for="(item, index) in imageInfo[0].detail" v-html="item" :key="index"></p>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid purpose">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="image-info-background text-left">
              <img :src="`/${$staticPath}/${imageInfo[1].imageInfoBackground}`">
              <div class="content-image" :style="purposeStyle">
                <h1>
                  <strong>{{ imageInfo[1].header.head }}</strong>{{ imageInfo[1].header.text }}<div class="underline"></div>
                </h1>
                <div class="px-4 group">
                  <p v-for="(item, index) in imageInfo[1].detail" v-html="item" :key="index"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import HeaderBar from '../COMMON/HeaderBar'

export default {
  components: {
    HeaderBar
  },
  props: ['headerBar', 'imageInfo'],
  data () {
    return {
      imageInfoBackground: `/${this.$staticPath}/images/Dormitory/office/vision.jpg`,
      visionStyle: {
        left: '15%',
        backgroundColor: 'rgba(220, 220, 220, 0.5)',
        width: '55%'
      },
      purposeStyle: {
        left: '35%',
        width: '65%',
        backgroundColor: 'rgba(255, 255, 255, 0.6)'
      }
    }
  }
}
</script>

<style scoped>
  @import url('../../../static/css/dormitory-style/vision.css');
</style>



// WEBPACK FOOTER //
// src/components/DORM/Vision.vue